<template src="./Carrusel.html"></template>
<script>
import metodos_comunes from '../../js/metodos_comunes';
import TarjetasOrdenes from "../TarjetasOrdenes/TarjetasOrdenes";
import VueAwesomeSwiper from "vue-awesome-swiper";

export default {
  data() {
    return {
      expand:true,
      
      search: "",
      page: 1,
      itemsPerPage: 3,
      copyArrayOrdenes: this.arrayOrdenes
    };
  },
  components: {
    TarjetasOrdenes,
    VueAwesomeSwiper
  },
  props: {
    arrayOrdenes: {
      type: Array
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.arrayOrdenes.length / this.itemsPerPage);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    customFilter() {
      const buscar = this.search.toString().toLowerCase();
      if (buscar === "" || !buscar) {
        this.copyArrayOrdenes = this.arrayOrdenes;
        return;
      }
      
      const array = this.arrayOrdenes.filter(orden => {
        const find = orden.variables.filter(variable => {
          
          if (
            (variable.valor &&
            metodos_comunes.reemplazarCaracteresEspeciales(variable.valor.toString().toLowerCase()).includes(buscar)) || (variable.nombre &&
            metodos_comunes.reemplazarCaracteresEspeciales(variable.nombre.toString().toLowerCase()).includes(buscar))
          ) {
            return variable;
          }
        })[0];
        return find;
      });
      this.copyArrayOrdenes = array;
    }
  }
};
</script>
<style lang="scss" scoped  src="./Carrusel.scss">
</style>


// WEBPACK FOOTER //
// src/components/Carrusel/Carrusel.vue